<template>
  <div class="content-wrap">
    <header class="content-header cf">
      <h3>{{ $t('meta.areas') }}</h3>
      <div class="header-meta">
        <Link
          :to="`/company/sites/${this.$route.params.site_uuid}/areas/new`"
          class="button button-green button-small button-round"
          >{{ $t('sites.addArea') }}</Link
        >
      </div>
    </header>
    <div class="content-body">
      <div v-if="site.areas">
        <div v-if="site.areas.length === 0" class="alert alert-danger">{{ $t('sites.noAreas') }}</div>
        <Table>
          <template #header>
            <th>{{ $t('meta.name') }}</th>
            <th>{{ $t('meta.sitePlan') }}</th>
            <th></th>
          </template>
          <template #body>
            <tr v-for="area in site.areas" :key="area.uuid">
              <td>{{ area.name }}</td>
              <td>
                <ImageComponent v-if="area.image" :preview="area.image.previewUrl" :src="area.image.url" />
              </td>
              <td class="table__actions">
                <Link :to="`/company/sites/${site.uuid}/areas/${area.uuid}`" class="table__action-button"
                  ><span class="material-icons">edit</span></Link
                >
                <button @click="deleteArea(area.uuid)" class="table__action-button">
                  <span class="material-icons">delete</span>
                </button>
              </td>
            </tr>
          </template>
        </Table>
      </div>
    </div>
  </div>
</template>

<script>
import ImageComponent from '@/components/Image'
import Table from '@/components/Table/index.vue'

import areasApi from '@/api/areas'

export default {
  name: 'AreasIndex',
  inject: ['showPopup'],
  components: {
    Table,
    ImageComponent,
  },
  props: {
    site: { type: Object, required: true },
  },
  methods: {
    async deleteArea(areaUuid) {
      if (await this.showPopup({ content: this.$t('sites.deleteAreaConfirmation'), type: 'confirm' })) {
        await areasApi.delete(this.$route.params.site_uuid, areaUuid)
        this.$emit('reloadSite')
      }
    },
  },
}
</script>
